var map = {
	"./bird_placeholder_1.png": 667,
	"./bird_placeholder_2.png": 668,
	"./bird_placeholder_3.png": 669,
	"./bird_placeholder_4.png": 670,
	"./coral_reef.png": 671,
	"./india_offshore_wind.png": 672,
	"./india_onshore_wind.png": 673,
	"./india_powerline_distribution.png": 674,
	"./india_powerline_transmission.png": 675,
	"./india_solar.png": 676,
	"./mangrove.png": 677,
	"./nepal_onshore_wind.png": 678,
	"./nepal_powerline_distribution.png": 679,
	"./nepal_powerline_transmission.png": 680,
	"./nepal_solar.png": 681,
	"./seagrass.png": 682,
	"./thailand_offshore_wind.png": 683,
	"./thailand_onshore_wind.png": 684,
	"./thailand_powerline_distribution.png": 685,
	"./thailand_powerline_transmission.png": 686,
	"./thailand_solar.png": 687,
	"./vietnam_offshore_wind.png": 688,
	"./vietnam_onshore_wind.png": 689,
	"./vietnam_powerline_distribution.png": 690,
	"./vietnam_powerline_transmission.png": 691,
	"./vietnam_solar.png": 692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 934;